<template>
  <div>
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>
    <div class="box">
      <admin-box-item title="전송 시점 등록">
        <div class="columns is-multiline">
          <div class="column is-full">
            <admin-form-item label="영어명(키값으로 사용)*">
              <input class="input"
                     :value="value.name"
                     @input="e => value.name = e.target.value"
                     type="text"
                     maxlength="50">
            </admin-form-item>
          </div>
          <div class="column is-full">
            <admin-form-item label="한글명*">
              <input class="input"
                     :value="value.kor_name"
                     @input="e => value.kor_name = e.target.value"
                     type="text"
                     maxlength="50">
            </admin-form-item>
          </div>
          <div class="column is-full">
            <admin-form-item label="변수" desc="템플릿 메세지에 추가할 변수를 구성하세요.">
              <div v-for="(item, item_idx) in value.variables"
                   :key="`item-${item_idx}`"
                   style="margin-top:8px">
                <div class="flex-align">
                  <input class="input"
                         placeholder="변수키"
                         style="margin-right:8px"
                         :value="item.key"
                         @input="e => item.key = e.target.value"
                         type="text"
                         maxlength="50">
                  <input class="input"
                         placeholder="변수명"
                         :value="item.val"
                         @input="e => item.val = e.target.value"
                         type="text"
                         maxlength="50">
                  <i class="material-icons unselect"
                     v-if="item_idx<value.variables.length-1"
                     @click="removeVariable(item_idx)">remove</i>
                  <i class="material-icons unselect"
                     @click="value.variables.push({key:'',val:''})" v-if="item_idx===value.variables.length-1">add</i>
                </div>
              </div>
            </admin-form-item>
          </div>
          <div class="column is-full">
            <admin-form-item label="전송대상">
              <lp-check-group :list="targetArr"
                              :data="selectedTarget"
                              value_name="value"
                              label_name="label"></lp-check-group>
            </admin-form-item>
          </div>
          <div class="column is-full">
            <admin-form-item label="패키지명">
              <span class="select">
                <select v-model="value.package" @change="e => value.package=e.target.value">
                  <option :value="item.value" v-for="(item, idx) in packages"
                          :key="'pack-'+idx">{{ item.label }}</option>
                </select>
              </span>
            </admin-form-item>
          </div>
          <div class="column is-full">
            <admin-form-item label="사용 여부">
              <lp-radio :val.sync="value.enable"
                        value_name="value"
                        label_name="label"
                        :data="[{label:'사용',value:true}, {label:'사용 안 함', value:false}]"></lp-radio>
            </admin-form-item>
          </div>
        </div>
      </admin-box-item>
    </div>
  </div>
</template>
<script>
  import LpRadio from "../../../module/common/LpRadio";
  import LpCheckGroup from "../../../module/common/LpCheckGroup";

  export default {
    name: "SmsSendPointCreate",
    components: {LpCheckGroup, LpRadio},
    created() {
      this.$axios.get('public/package').then(res => {
        if (res.status === 200) {
          this.packages = res.data;
        }
      })

      if(this.$route.query.id) {
        this.selectedTarget = [];
        this.$axios.get(this.getUrl(`launchpack/sms_send_point/${this.$route.query.id}`)).then(res => {
          this.value = res.data;
          this.value.targets.forEach(item => {
            this.selectedTarget.push(item.value);
          })
        })
      }
    },
    data() {
      return {
        packages: [],
        value: {
          name: "",
          kor_name: "",
          variables: [{key: '', val: ''}],
          package: "",
          enable: false
        },
        targetArr: [
          {label:'회원',value:'user'},
          {label:'관리자',value:'admin'},
          {label:'파트너',value:'partner'}
        ],
        selectedTarget: []
      }
    },
    methods: {
      removeVariable(idx) {
        removeIndex(this.value.variables, idx);
      },
      saveData() {
        let err = '';
        if (!this.value.name) {
          err = '영어명(키값으로 사용)는 필수입력값입니다.'
        }
        if (!this.value.kor_name) {
          err = '한글명은 필수입력값입니다.'
        }
        if(this.value.variables.length>0) {
          let result = this.value.variables.some(item => {
            return !item.key || !item.val
          })
          if(result) {
            err = '변수키, 변수명을 알맞게 입력하세요.'
          }
        }
        if (err) {
          this.toast(err);
          return;
        }
        let targets = [];
        this.selectedTarget.forEach(item=> {
          this.targetArr.forEach(item2=> {
            if(item2.value===item) {
              targets.push(item2)
            }
          })
        })
        this.value.targets = targets;

        if(this.$route.query.id) {
          this.$axios.patch(this.getUrl(`launchpack/sms_send_point/${this.$route.query.id}`), this.value).then(res => {
            this.toast('저장되었습니다.');
            // this.$router.replace(this.getPath('launchpack/sms_send_point'))
          })
        } else {
          this.$axios.get('admin/launchpack/sms_send_point/name/check', {
            params: {
              name: this.value.name
            }
          }).then(res => {
            this.$axios.post(this.getUrl('launchpack/sms_send_point'), this.value).then(res => {
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath('launchpack/sms_send_point'))
            })
          }).catch(error => {
            if (error.response) {
              if (error.response.data.message) {
                this.toast(error.response.data.message);
              } else {
                this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
              }
            } else {
              this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
            }
          })
        }
      }
    }
  }
</script>
<style lang="stylus" scoped>
</style>
